import { render, staticRenderFns } from "./servePeople.vue?vue&type=template&id=08506afb&scoped=true&"
import script from "./servePeople.vue?vue&type=script&lang=js&"
export * from "./servePeople.vue?vue&type=script&lang=js&"
import style0 from "./servePeople.vue?vue&type=style&index=0&id=08506afb&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08506afb",
  null
  
)

export default component.exports